import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { ToastContainer, toast } from "react-toastify";
import dataTableGrid from "../DataTableGrid";
import {
  deleteData,
  getAdministratorUserList,
} from "../../Utils/adminFunctions";

let ManageAdministratorUser = () => {
  const [listUsers, setListUsers] = useState([]);
  useEffect(() => {
    manageAdministratorsUser();
  }, []);

  const manageAdministratorsUser = async () => {
    const bodyFormData = new FormData();
    const response = await getAdministratorUserList(bodyFormData);
    if (response.status === "success") {
      setListUsers(response.optionItems);
      dataTableGrid({
        data_table_id: "#userlist",
        paginate: false,
        copy_option: [0, 1, 2, 3, 4, 5, 6],
        csv_option: [0, 1, 2, 3, 4, 5, 6],
        print_option: [0, 1, 2, 3, 4, 5, 6],
        sort_option: [7, 8],
      });
    } else if (response.status === "failure") {
      setListUsers(response.optionItems);
    } else {
      toast.error(response, { autoClose: 1500 });
    }
  };

  const handleUserDeleteRecord = async () => {
    let uID = document.getElementById("deleteUser").value;
    const response = await deleteData(uID, "USERS");
    if (response.status == "success") {
      toast.success(response.message, { autoClose: 1500 });
      document.getElementById("close_modal").click();
      manageAdministratorsUser();
    } else {
      toast.warning(response.message, { autoClose: 1500 });
      document.getElementById("close_modal").click();
    }
  };

  return (
    <div>
      <div className="wrapper">
        <input type="hidden" id="deleteUser" value=""></input>
        <div className="modal fade show" id="modal-default" arial-modal="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Confirm delete</h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="close_modal"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this record?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  data-dismiss="modal"
                  className="btn btn-sm btn-dark"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() => handleUserDeleteRecord()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <ToastContainer></ToastContainer>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header">
                        <div className="row">
                          <div className="col-md-8">
                            <h3 className="card-title card-header-link custom-link-primary">
                              <b>Administrator Users </b>{" "}
                            </h3>
                          </div>

                          <div className="col-md-4">
                            <h3 className="card-title pull-right ">
                              <Link
                                to={"/AddAdministratorUser"}
                                className="btn btn-sm custom-btn-primary"
                              >
                                <i className="fa fa-plus"></i> Add User
                              </Link>{" "}
                              {/* <Link
                                to="/ManageAdministratorUser"
                                className="btn btn-sm custom-btn-primary"
                              >
                                <i className="fa fa-arrow-left"></i> Back
                              </Link> */}
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <table
                          id="userlist"
                          className="table table-bordered table-striped"
                        >
                          <thead>
                            <tr>
                              <th>S. No.</th>
                              <th>First Name</th>
                              <th>Last Name</th>
                              <th>Email</th>
                              <th>Department</th>
                              <th>User Type</th>
                              <th>Status</th>
                              <th>Created On</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>{listUsers}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default ManageAdministratorUser;
